import { FETCH_ALL_FINAL_INVOICES, DELETE_FINAL_INVOICE } from "../actions/types";
import _ from 'lodash';
const INITIAL_STATE = {data: {},paginate:{}}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ALL_FINAL_INVOICES:
            const paginate = _.omit(action.payload, 'data');
            return {...state, data:_.mapKeys(action.payload.data, 'id'), paginate}
        case DELETE_FINAL_INVOICE:
            return {...state, data:_.omit(state.data, action.payload)};
        default:
            return state;
    }
}